import { render } from "./App.vue?vue&type=template&id=b0775fe4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b0775fe4&lang=css"
script.render = render

export default script